import * as Yup from 'yup';

export const confirmFormValidation = Yup.object().shape({
  token: Yup.string().length(6, "The activation token contains 6 digits")
    .required("You need to enter your TVBIZZ activation token")
})
